module.exports = __webpack_public_path__ + "static/SFMono-RegularItalic-bb1fc3ab1772befac3587b30ca876a09.woff2";